import React, { ReactNode } from 'react';

interface AdminCardProps {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  className?: string;
  headerAction?: ReactNode;
}

/**
 * AdminCard - Reusable card component for admin pages
 * Follows the design system with Tailwind CSS
 */
export const AdminCard: React.FC<AdminCardProps> = ({
  children,
  title,
  subtitle,
  className = '',
  headerAction,
}) => {
  return (
    <div
      className={`
        w-full p-6 md:p-8
        bg-[#2a2a2a]
        rounded-2xl
        flex flex-col gap-5
        ${className}
      `}
    >
      {(title || headerAction) && (
        <div className="flex items-center justify-between gap-4">
          <div>
            {title && (
              <h2 className="text-[#F4CC04] text-xl font-semibold">
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="text-[#888888] text-sm mt-1">
                {subtitle}
              </p>
            )}
          </div>
          {headerAction && (
            <div className="flex-shrink-0">
              {headerAction}
            </div>
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export default AdminCard;
